import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';
import { reviewSortSchema, reviewRatingFilterSchema } from '@/entities/review';
import { ReviewsPage } from '@/pages/reviews';
import { requireAuth } from '../require-auth';

/**
 * Reviews route — the URL is the single source of truth for the two filter
 * pills (CLAUDE.md §2's state-boundary table), so a filtered feed is shareable
 * and the back button steps through filter changes.
 *
 * Both params `.catch()` their default rather than failing validation: a
 * hand-edited or stale `?sort=whatever` should show the unfiltered feed, not
 * blank the route with a search-param error.
 */
const reviewsSearchSchema = z.object({
  sort: reviewSortSchema.catch('default').default('default'),
  rating: reviewRatingFilterSchema.catch('default').default('default'),
});

// No loader prefetch — the list is keyed by the merchant scope the guard
// establishes. See `eats.branches.tsx`.
export const Route = createFileRoute('/eats/reviews')({
  // Auth guard — see `require-auth.ts`. Runs before the component mounts,
  // so no query fires without a session.
  beforeLoad: requireAuth,
  validateSearch: reviewsSearchSchema,
  component: ReviewsRoute,
});

function ReviewsRoute() {
  const { sort, rating } = Route.useSearch();
  return <ReviewsPage sort={sort} rating={rating} />;
}
